import React from 'react'

const TeamName = ({ name, teamSize }) => {
  let nameElement = <div className="team-normal team-name">{name}</div>,
    subElement = null
  if (name.length > 10) {
    subElement = (
      <span>
        <br />
        {name.slice(12, name.length)}
      </span>
    )
  }
  if (teamSize > 10) {
    nameElement = (
      <div className="team-small team-name">
        {name.slice(0, 12)}
        {subElement}
      </div>
    )
  }
  return nameElement
}

export default TeamName
